import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import "./loader.css";

const SHOW_DELAY = 120;
const MIN_VISIBLE_TIME = 350;

function useDelayedVisibility(active) {
  const [visible, setVisible] = useState(false);
  const shownAt = useRef(0);

  useEffect(() => {
    let timer;

    if (active) {
      timer = window.setTimeout(() => {
        shownAt.current = Date.now();
        setVisible(true);
      }, SHOW_DELAY);
    } else if (visible) {
      const elapsed = Date.now() - shownAt.current;
      timer = window.setTimeout(
        () => setVisible(false),
        Math.max(0, MIN_VISIBLE_TIME - elapsed),
      );
    }

    return () => window.clearTimeout(timer);
  }, [active, visible]);

  return visible;
}

export function LoadingBar({ active = true }) {
  const visible = useDelayedVisibility(active);

  return (
    <div
      className={`top-loading-bar${visible ? " is-visible" : ""}`}
      role="progressbar"
      aria-label="Loading"
      aria-hidden={!visible}
    >
      <span className="top-loading-bar__track" />
    </div>
  );
}

export function GlobalLoadingBar() {
  const hasPendingRequest = useSelector((state) => {
    const apiState = state.dmApi;
    if (!apiState) return false;

    return [...Object.values(apiState.queries || {}), ...Object.values(apiState.mutations || {})]
      .some((request) => request?.status === "pending");
  });

  return <LoadingBar active={hasPendingRequest} />;
}
